import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { LearningJourneyManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/learning-journeys")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <LearningJourneyManagement />
    </RouteGuard>
  ),
});
